import {
  getTableViewsGetQueryKey,
  useTableViewDelete,
} from "gen/endpoints/table-views/table-views";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useToast } from "shared/components/toast/useToast";
import { rootRoute } from "shared/navigation/Routes";
import { useInvalidateQueryKeys } from "shared/utils/QueryUtils";

export const useDeleteView = ({
  existingViewId,
}: {
  existingViewId?: string;
}) => {
  const { t } = useTranslation(["common", "views"]);
  const navigate = useNavigate();
  const deleteMutationPending = useTableViewDelete();
  const { mutateAsync: deletePendingMutateAsync } = deleteMutationPending;
  const invalidateQuery = useInvalidateQueryKeys();
  const { showToast } = useToast();
  const deleteView = async () => {
    if (!existingViewId) {
      return;
    }
    await deletePendingMutateAsync({
      viewId: existingViewId,
    });
    showToast({
      message: t("views:toasts.deleted"),
      variant: "success",
    });
    await invalidateQuery(getTableViewsGetQueryKey());
    navigate(rootRoute({}).transactions({}).$, {
      replace: true,
    });
  };

  return { deleteView, isDeleting: deleteMutationPending.isPending };
};
